import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

import { ScrollReveal, ScrollRevealItem } from '@shared/directives';

@Component({
  selector: 'app-we-believe',
  imports: [NgOptimizedImage, ScrollReveal, ScrollRevealItem],
  templateUrl: './we-believe.html',
  styleUrl: './we-believe.scss',
})
export class WeBelieve {
  protected readonly convictionParagraphs: readonly string[] = [
    'The current state of generative media stands at the opposite end of what modernism promised. The capability of the maker to go to the essence of a piece. The discipline of restriction, control, and rigor in service of the work.',
    'Professionals creatives in every field, cinematographers, VFX supervisors, brand directors, have always demanded deterministic control over their output. A cinematographer does not accept a random lens choice. A set designer does not accept almost right. The fact that generative tools have normalized probabilistic output as acceptable for professional work is the real scandal.',
    'We built EVRN to give makers control over their creative tools, so humans keep full authorship in the age of advanced machines.',
    'The future of storytelling belongs to the people who direct it, not the ones gambling on what the algorithm comes up with.',
  ];
}
